var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenCloth = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 18.5c0 .827-.673 1.5-1.5 1.5h-3.548l-.938-9.385 2.724-4.54L20 6.891zM10.053 20l.9-9h2.094l.9 9zM5.5 20c-.827 0-1.5-.673-1.5-1.5V6.891l3.262-.816 2.724 4.54L9.048 20zm8.65-11.557L12.707 7l2.656-2.656.567 1.134zM9.707 4h4.586L12 6.293zm1.586 3L9.85 8.443 8.07 5.478l.567-1.134zm1.924 3h-2.434l-.403-.673L12 7.707l1.62 1.62zm3.627-4.929L15.809 3H8.191L7.156 5.071 3 6.109V18.5C3 19.878 4.122 21 5.5 21h13c1.378 0 2.5-1.122 2.5-2.5V6.109z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenCloth);
export default ForwardRef;